"use client"
export const InputInfoElements = ({ children }) => <div className={`gap-6 md:gap-[22px] flex flex-col relative`}>{children}</div>
